<template>
  <h4>Примечание: <i>{{ description }}</i></h4>
</template>

<script>
  export default {
    name: "PlayerDescriptionLabel",
    props: ['description'],
  }
</script>

<style scoped>
  h4 {
    font-size: 12px;
    color: #666;
    font-family: Verdana,sans-serif;
    font-weight: normal;
  }
</style>

